import script from "./TaxReductionStatement.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxReductionStatement.vue?vue&type=script&setup=true&lang=ts"

import "./TaxReductionStatement.vue?vue&type=style&index=0&id=56887d5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56887d5c"]])

export default __exports__